import { __awaiter } from '../../_virtual/_tslib.js';
import { useQueryClient, useQuery } from 'react-query';
import { useVahakMutationQuery } from '../../hooks/useVahakQueryClient.js';
import useVahakHttpClient from '../../hooks/useVahakHttpClient.js';
import { getAuthIdParam } from '../../methods/getAuthIdParam.js';
import API from '../const.js';
import { getAuthHeader } from '../utils/getAuthHeader.js';
import { handleMutateResponse } from '../utils/handleMutateResponse.js';
import { QueryNames } from './queryNames.js';

/**
 * Get Lorry by Id
 */
function useGetLorryById(lorryId, options) {
    const queryClient = useQueryClient();
    return useQuery([QueryNames.userLorries.getLorryById, lorryId], () => fetch(`${API.USER_LORRY_INFO_BY_ID}${getAuthIdParam()}&l_i=${lorryId}`, {
        method: "GET",
        headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader())
    }).then((res) => {
        if (res.status === 401) {
            queryClient.invalidateQueries();
            return;
        }
        else {
            return res.json().then((jsonData) => {
                const allData = jsonData.data;
                return allData;
            });
        }
    }), {
        enabled: options === null || options === void 0 ? void 0 : options.enabled,
        onSuccess: options === null || options === void 0 ? void 0 : options.onSuccess,
        onError: options === null || options === void 0 ? void 0 : options.onError,
        refetchInterval: options === null || options === void 0 ? void 0 : options.refetchInterval,
        staleTime: options === null || options === void 0 ? void 0 : options.staleTime,
        cacheTime: options === null || options === void 0 ? void 0 : options.cacheTime,
        select: options === null || options === void 0 ? void 0 : options.select
    });
}
/**
 * Get Routes of lorry
 */
function useLorryRoutes(lorryId, options) {
    const queryClient = useQueryClient();
    return useQuery([QueryNames.userLorries.getLorryRoutes, lorryId], () => fetch(`${API.USER_LORRY_ROUTES_BY_ID}${getAuthIdParam()}&l_i=${lorryId}`, {
        method: "GET",
        headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader())
    }).then((res) => {
        if (res.status === 401) {
            queryClient.invalidateQueries();
            return;
        }
        else {
            return res.json().then((jsonData) => {
                const allData = jsonData.data;
                return allData;
            });
        }
    }), {
        enabled: options === null || options === void 0 ? void 0 : options.enabled,
        onSuccess: options === null || options === void 0 ? void 0 : options.onSuccess,
        onError: options === null || options === void 0 ? void 0 : options.onError,
        refetchInterval: options === null || options === void 0 ? void 0 : options.refetchInterval,
        staleTime: options === null || options === void 0 ? void 0 : options.staleTime,
        cacheTime: options === null || options === void 0 ? void 0 : options.cacheTime,
        select: options === null || options === void 0 ? void 0 : options.select
    });
}
function handleLorryEdit(mutateFn, EditLorryParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, EditLorryParams);
    });
}
function useDeleteLorry() {
    const { POST } = useVahakHttpClient();
    const deleteLorry = ({ lorryId }) => {
        const payload = { id: lorryId };
        return POST(API.USER_DELETE_LORRY, payload);
    };
    return useVahakMutationQuery(QueryNames.userLorries.deleteLorry, deleteLorry);
}

export { handleLorryEdit, useDeleteLorry, useGetLorryById, useLorryRoutes };
//# sourceMappingURL=useLorryService.js.map
